import axios from "axios";
import label from "@/lang/StaticLabels.js";
import alert from "@/lang/AlertMessages.js";
const splyUrl = "sply/api/v1/";

// تصویر گروه کالا در فایلینگ نگهداری می‌شود (تک فایلی؛ آپلود دوباره جایگزین می‌کند)
const commodityGroupImageType = "CommodityGroup_Image";
const syncCommodityGroupImage = async (id, image, removeImage) => {
  if (!id || (!image && !removeImage)) return true;
  try {
    if (image) {
      const formData = new FormData();
      formData.append("IsDefault", false);
      formData.append("EntityId", id);
      formData.append("AttachmentTypeId", commodityGroupImageType);
      formData.append("Attachments[0].file", image);
      formData.append("Attachments[0].title", "");
      await axios.post("filing/api/v1/Upload", formData);
      return true;
    }
    const res = await axios.get(
      "filing/api/v1/Upload/GetDefaults?FolderName=" +
        commodityGroupImageType +
        "&EntityIds=" +
        id,
    );
    const ids = (res.data.data || []).map((z) => z.id).filter(Boolean);
    if (ids.length) {
      await axios.delete("filing/api/v1/Upload", { data: ids });
    }
    return true;
  } catch (error) {
    return false;
  }
};


const checkResultRows = (data) => {
  if (Array.isArray(data)) return data;
  if (!data) return [];
  const rows = (data.commodities || []).filter(
    (item) => item.severity || (item.messages && item.messages.length),
  );
  const texts = new Set();
  rows.forEach((item) =>
    (item.messages || []).forEach((m) => texts.add(m.text)),
  );
  (data.messages || []).forEach((m) => {
    if (m.text && !texts.has(m.text)) {
      rows.push({ message: m.text, severity: m.severity });
    }
  });
  return rows;
};

export default {
  // Unit Actions ------------------------------------------------------------------
  getUnits({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "basic/UnitCount")
      .then((res) => {
        commit("setUnits", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addUnit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/UnitCount", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editUnit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/UnitCount/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteUnit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/UnitCount/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getUnitCode({ dispatch, commit }) {
    axios
      .get(splyUrl + "basic/UnitCount/GetMaxCode")
      .then((res) => {
        commit("setUnitCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // WareCategory Actions ------------------------------------------------------------------
  getWareCategories({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "basic/WareCategory")
      .then((res) => {
        commit("setWareCategories", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addWareCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/WareCategory", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editWareCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/WareCategory/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteWareCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/WareCategory/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getWareCategoryCode({ dispatch, commit }) {
    axios
      .get(splyUrl + "basic/WareCategory/GetMaxCode")
      .then((res) => {
        commit("setWareCategoryCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Ware Actions ------------------------------------------------------------------
  getWares({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "basic/WareInfo")
      .then((res) => {
        commit("setWares", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getWare({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/WareInfo/" + data)
      .then((res) => {
        commit("setWare", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addWare({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/WareInfo", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editWare({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/WareInfo/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteWare({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/WareInfo/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getWareCode({ dispatch, commit }) {
    axios
      .get(splyUrl + "basic/WareInfo/GetMaxCode")
      .then((res) => {
        commit("setWareCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Commodity Category Actions ------------------------------------------------------------------
  getCommodityCategories({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "basic/CommodityGroup")
      .then((res) => {
        commit("setCommodityCategories", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // ثبت گروه کالا؛ data: { value, image } — تصویر بعد از ثبت با شناسهٔ برگشتی در فایلینگ بارگذاری می‌شود
  addCommodityCategory({ dispatch, commit }, data) {
    const { value, image } = data.value ? data : { value: data };
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(splyUrl + "basic/CommodityGroup", value)
      .then(async (res) => {
        const id = res.data.data?.id ?? res.data.data;
        const imageOk = await syncCommodityGroupImage(id, image, false);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        if (!imageOk) {
          commit("setError", alert.error.commodityGroupImageUploadFailed, {
            root: true,
          });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // ویرایش گروه کالا؛ data: { id, value, image, removeImage }
  editCommodityCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(splyUrl + "basic/CommodityGroup/" + data.id, data.value)
      .then(async (res) => {
        const imageOk = await syncCommodityGroupImage(
          data.id,
          data.image,
          data.removeImage,
        );
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        if (!imageOk) {
          commit("setError", alert.error.commodityGroupImageUploadFailed, {
            root: true,
          });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCommodityCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/CommodityGroup/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getCommodityCategoryCode({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "basic/CommodityGroup/GetMaxCode?HeadGroupId=" + data)
      .then((res) => {
        commit("setCommodityCategoryCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  importExcelCommodityCategory({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/CommodityGroup/ImportAsExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: res.data.message,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Commodity Actions ------------------------------------------------------------------
  getCommodities({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .get(splyUrl + "basic/Commodity?" + data)
      .then((res) => {
        commit("setCommodities", res.data.data);
        commit("setCommoditiesTotalCount", res.data.totalCount);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        commit("setCommodities", []);
        commit("setCommoditiesTotalCount", 0);
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCommodity({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "basic/Commodity/" + data)
      .then((res) => {
        commit("setCommodity", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addCommodity({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/Commodity", data)
      .then((res) => {
        commit("setCommodityInfo", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodity({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/Commodity/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCommodity({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/Commodity", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getCommodityCode({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/Commodity/GetMaxSerial/" + data)
      .then((res) => {
        commit("setCommodityCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  fetchCommodityNavigation(context, data) {
    return axios
      .get(splyUrl + "basic/Commodity/Navigation?" + data)
      .then((res) => res.data.data || null)
      .catch(() => null);
  },

  getCommodityNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "basic/Commodity/Navigation?" + data)
      .then((res) => {
        commit("setCommodityNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getCommodityBySearch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "basic/Commodity/Search?" + data)
      .then((res) => {
        commit("setCommodityBySearch", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addCommoditiesToWareInfos({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/Commodity/AddCommoditiesToWareInfos", data)
      .then((res) => {
        // commit("setCommodityInfo", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // getCommodityBarcodePrint({ dispatch }, data) {
  //   axios
  //     .post(splyUrl + "basic/Commodity/Print", data)
  //     .then((res) => {
  //       window.open(res.data.data);
  //     })
  //     .catch((error) => {
  //       dispatch("errorGETHandler", error, { root: true });
  //     });
  // },

  addCommodityFinancialInfo({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/CommodityFinancialInfo", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodityActiveInAllWare({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/Commodity/ActiveInAllWare", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodityActiveIsProduct({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/Commodity/ActiveIsProduct", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodityUnActiveIsProduct({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/Commodity/UnActiveIsProduct", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodityActiveIsMaterial({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/Commodity/ActiveIsMaterial", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodityUnActiveIsMaterial({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/Commodity/UnActiveIsMaterial", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodityActiveCommodity({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/Commodity/ActiveCommodity", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodityUnActiveCommodity({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/Commodity/UnActiveCommodity", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodityActiveIsService({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/Commodity/ActiveIsService", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodityUnActiveIsService({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/Commodity/UnActiveIsService", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodityUnChangeTax({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/Commodity/ChangeTax", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodityCodeAndBarcode({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/Commodity/ChangeCodeAndBarcode", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  importExcelCommodity({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/Commodity/ImportAsExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: res.data.message,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  changeCommodityParameter({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/Commodity/ChangeCommodityParameter", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Shelf Actions ------------------------------------------------------------------
  getShelfs({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/WareShelfInfo?wareInfoId=" + data)
      .then((res) => {
        commit("setShelfs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addShelf({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/WareShelfInfo", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editShelf({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/WareShelfInfo/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteShelf({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/WareShelfInfo/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getShelfCode({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/WareShelfInfo/GetMaxCode/" + data)
      .then((res) => {
        commit("setShelfCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  importExcelShelf({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/WareShelfInfo/ImportAsExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: res.data.message,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Commodity Barcode Actions ------------------------------------------------------------------
  getCommodityBarcodes({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/CommodityBarcode/" + data)
      .then((res) => {
        commit("setCommodityBarcodes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCommodityBarcode({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/CommodityBarcode", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodityBarcode({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/CommodityBarcode/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCommodityBarcode({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/CommodityBarcode/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  printCommodityBarcode({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/CommodityBarcode/Print/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Commodity UnitCount Actions ------------------------------------------------------------------
  getCommodityUnitCounts({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/CommodityUnitContainer/" + data)
      .then((res) => {
        commit("setCommodityUnitCounts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCommodityUnitCount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/CommodityUnitContainer", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodityUnitCount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/CommodityUnitContainer/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCommodityUnitCount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/CommodityUnitContainer/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Commodity Ware Actions ------------------------------------------------------------------
  addCommodityWare({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/CommodityWareContainer", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCommodityWare({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/CommodityWareContainer/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Commodity Image Actions ------------------------------------------------------------------
  getCommodityImages({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/CommodityImage/" + data)
      .then((res) => {
        commit("setCommodityImages", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCommodityImage({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/CommodityImage", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCommodityImage({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/CommodityImage", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Attachment Image Actions ------------------------------------------------------------------
  getCommodityAttachments({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/CommodityAttachment?commodityId=" + data)
      .then((res) => {
        commit("setCommodityAttachments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCommodityAttachment({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/CommodityAttachment/" + data)
      .then((res) => {
        commit("setCommodityAttachment", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCommodityAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/CommodityAttachment", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCommodityAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/CommodityAttachment", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Commodity Feature Actions ------------------------------------------------------------------
  getCommodityFeatures({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/CommodityFeature?commodityId=" + data)
      .then((res) => {
        commit("setCommodityFeatures", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCommodityFeature({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/CommodityFeature", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodityFeature({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/CommodityFeature/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCommodityFeature({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/CommodityFeature", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getCommodityFeatureCode({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/CommodityFeature/MaxCode?commodityId=" + data)
      .then((res) => {
        commit("setCommodityFeatureCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // WareVoucherType Actions ------------------------------------------------------------------
  getWareVoucherTypes({ dispatch, commit }) {
    axios
      .get(splyUrl + "basic/WareVoucherType")
      .then((res) => {
        commit("setWareVoucherTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getWareVoucherType({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/WareVoucherType/" + data)
      .then((res) => {
        commit("setWareVoucherType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addWareVoucherType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/WareVoucherType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editWareVoucherType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/WareVoucherType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteWareVoucherTypes({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/WareVoucherType/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getWareVoucherTypeCode({ dispatch, commit }) {
    axios
      .get(splyUrl + "basic/WareVoucherType/MaxCode")
      .then((res) => {
        commit("setWareVoucherTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // AdditionalCommodityParameter Actions ------------------------------------------------------------------
  getAdditionalCommodityParameters({ dispatch, commit }) {
    axios
      .get(splyUrl + "basic/AdditionalCommodityParameter")
      .then((res) => {
        commit("setAdditionalCommodityParameters", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // با ارسال { silent: true, value: form } ذخیره بدون نمایش پیام موفقیت انجام
  // می‌شود (ذخیرهٔ خودکار هنگام باز کردن مدال مدیریت لیست)؛ خطاها همچنان نمایش
  // داده می‌شوند
  addAdditionalCommodityParameter({ dispatch, commit }, data) {
    const silent = data && data.silent === true;
    const body = silent ? data.value : data;
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(splyUrl + "basic/AdditionalCommodityParameter", body)
      .then((res) => {
        if (silent && res && res.status === 200) {
          return;
        }
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // ParameterValue Actions ------------------------------------------------------------------
  getParameterValues({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/ParameterValue/" + data)
      .then((res) => {
        commit("setParameterValues", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addParameterValue({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/ParameterValue", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editParameterValue({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/ParameterValue/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteParameterValue({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/ParameterValue/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // TempReceipt Actions ------------------------------------------------------------------
  getTempReceipts({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/tempReceipt?" + data)
      .then((res) => {
        commit("setTempReceipts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getTempReceipt({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/TempReceipt/GetBy?" + data)
      .then((res) => {
        commit("setTempReceipt", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addTempReceipt({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/tempReceipt", data)
      .then((res) => {
        commit("setTempReceiptCreateResult", res.data.data);
        commit("setTempReceiptId", res.data.data?.id);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editTempReceipt({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/tempReceipt/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteTempReceipt({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/tempReceipt", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getTempReceiptCode({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/tempReceipt/maxCode?wareId=" + data)
      .then((res) => {
        commit("setTempReceiptCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTempReceiptSerial({ dispatch, commit }) {
    axios
      .get(splyUrl + "operation/TempReceipt/MaxSerial")
      .then((res) => {
        commit("setTempReceiptSerial", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  fetchTempReceiptNavigation(context, data) {
    return axios
      .get(splyUrl + "operation/tempReceipt/navigation?" + data)
      .then((res) => res.data.data || null)
      .catch(() => null);
  },

  getTempReceiptNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/tempReceipt/navigation?" + data)
      .then((res) => {
        commit("setTempReceiptNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getTempReceiptCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/tempReceipt/confirmCartable")
      .then((res) => {
        commit("setTempReceiptCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addTempReceiptConfirm({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/tempReceipt/confirm", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getTempReceiptExitCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/tempReceipt/exitCartable")
      .then((res) => {
        commit("setTempReceiptExitCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addTempReceiptExit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/tempReceipt/exit", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  importExcelTempReceipt({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/TempReceipt/ImportAsExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: res.data.message,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintTempReceipt({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(splyUrl + "operation/TempReceipt/Print/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // Receipt Actions ------------------------------------------------------------------
  getReceipts({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/Receipt?" + data)
      .then((res) => {
        commit("setReceipts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getReceipt({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/Receipt/GetBy?" + data)
      .then((res) => {
        commit("setReceipt", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReceiptByBarcode({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/Receipt/GetReceiptByBarcode?" + data)
      .then((res) => {
        commit("setReceiptByBarcode", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addReceipt({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Receipt", data)
      .then((res) => {
        commit("setReceiptCreateResult", res.data.data);
        commit("setReceiptId", res.data.data?.id);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addFinancialReceipt({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Receipt/CreateFinancial", data)
      .then((res) => {
        commit("setReceiptCreateResult", res.data.data);
        commit("setReceiptId", res.data.data?.id);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReceipt({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/Receipt/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editFinancialReceipt({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(splyUrl + "operation/Receipt/UpdateFinancial/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReceipt({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/Receipt", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReceiptCode({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/Receipt/MaxCode?wareId=" + data)
      .then((res) => {
        commit("setReceiptCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReceiptSerial({ dispatch, commit }) {
    axios
      .get(splyUrl + "operation/Receipt/MaxSerial")
      .then((res) => {
        commit("setReceiptSerial", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // نسخه‌ی بدون commit ناوبری؛ برای یافتن برگه بعدی/قبلی پیش از حذف
  fetchReceiptNavigation(context, data) {
    return axios
      .get(splyUrl + "operation/Receipt/Navigation?" + data)
      .then((res) => res.data.data || null)
      .catch(() => null);
  },

  getReceiptNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/Receipt/Navigation?" + data)
      .then((res) => {
        commit("setReceiptNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintReceipt({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(splyUrl + "operation/Receipt/Print/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getReceiptCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/Receipt/ReceiptNoVoucher")
      .then((res) => {
        commit("setReceiptCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getReceiptVerification({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/Receipt/ReceiptCartable")
      .then((res) => {
        commit("setReceiptVerificationCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addReceiptChangeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios

      .post(splyUrl + "operation/receipt/changeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  receiptReturnStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios

      .post(splyUrl + "operation/Receipt/Return", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReceiptConfirmCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/receipt/confirmCartable")
      .then((res) => {
        commit("setReceiptConfirmCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addReceiptConfirm({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/receipt/confirm", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReceiptUnConfirmCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/receipt/unConfirmCartable")
      .then((res) => {
        commit("setReceiptUnConfirmCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addReceiptUnConfirm({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Receipt/ChangeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // صدور فاکتور خرید از روی رسید(های) انبار
  // data: { receiptIds: [id], mode, buyFactorId, buyTypeId }
  createBuyFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Receipt/CreateBuyFactor", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // صدور فاکتور مرجوعی فروش از روی رسید(های) انبار
  // data: { receiptIds: [id], mode, returnSaleFactorId, saleTypeId }
  createReturnSaleFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Receipt/CreateReturnSaleFactor", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReadBuyRequestByCode({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/Receipt/ReadBuyRequest?code=" + data)
      .then((res) => {
        commit("setReadBuyRequestByCode", res.data.data);
        dispatch(
          "successPOSTHandlerSilent2",
          {
            server: res,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReadBuyRequestByCommodity({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/Receipt/ReadBuyRequest?commodityId=" + data)
      .then((res) => {
        commit("setReadBuyRequestByCommodity", res.data.data);
        dispatch(
          "successPOSTHandlerSilent2",
          {
            server: res,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  importExcelReceipt({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Receipt/ImportAsExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: res.data.message,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addReceiptCheckDelete({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Receipt/CheckDelete", data)
      .then((res) => {
        commit("setReceiptCheckDelete", res.data.data);
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addReceiptCheckUpdate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(splyUrl + "operation/Receipt/CheckUpdate/" + data.id, data.value)
      .then((res) => {
        commit("setReceiptCheckUpdate", res.data.data);
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReceiptVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Receipt/GetAddVoucher", data)
      .then((res) => {
        commit("setReceiptVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addReceiptVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Receipt/IssuanceVoucher", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReceiptVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/Receipt/DeleteVoucher", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // ManagementCartable..................................................................
  getReceiptManagementCartable({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/Receipt/ReceiptManagementCartableList?" + data)
      .then((res) => {
        commit("setReceiptManagementCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getDraftManagementCartable({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/Draft/DraftManagementCartableList?" + data)
      .then((res) => {
        commit("setDraftManagementCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // ReceiptAttachment Actions ------------------------------------------------------------------
  getReceiptAttachments({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/ReceiptAttach?receiptId=" + data)
      .then((res) => {
        commit("setReceiptAttachments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addReceiptAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/ReceiptAttach", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReceiptAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/ReceiptAttach", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Draft Actions ------------------------------------------------------------------
  getDrafts({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/Draft?" + data)
      .then((res) => {
        commit("setDrafts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getDraft({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/Draft/GetBy?" + data)
      .then((res) => {
        commit("setDraft", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addDraft({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Draft", data)
      .then((res) => {
        commit("setDraftCreateResult", res.data.data);
        commit("setDraftId", res.data.data?.id);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addFinancialDraft({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Draft/CreateFinancial", data)
      .then((res) => {
        commit("setDraftCreateResult", res.data.data);
        commit("setDraftId", res.data.data?.id);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  async copyDraft({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    try {
      const res = await axios.post(splyUrl + "operation/Draft/Copy/" + data);
      dispatch(
        "successPOSTHandlerSimple",
        {
          server: res,
          message: res.data.message,
        },
        { root: true },
      );
      return res.data.data;
    } catch (error) {
      dispatch("errorPOSTHandler", error, { root: true });
      return null;
    } finally {
      setTimeout(() => {
        commit("setLoadingBtn", false, { root: true });
      }, 1000);
    }
  },

  async copyFinancialDraft({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    try {
      const res = await axios.post(
        splyUrl + "operation/Draft/CopyFinancial/" + data,
      );
      dispatch(
        "successPOSTHandlerSimple",
        {
          server: res,
          message: res.data.message,
        },
        { root: true },
      );
      return res.data.data;
    } catch (error) {
      dispatch("errorPOSTHandler", error, { root: true });
      return null;
    } finally {
      setTimeout(() => {
        commit("setLoadingBtn", false, { root: true });
      }, 1000);
    }
  },

  async getDraftFromReceiptForm({ dispatch, commit }, receiptId) {
    commit("setLoadingBtn", true, { root: true });
    try {
      const res = await axios.get(
        splyUrl + "operation/Draft/FromReceiptForm/" + receiptId,
      );
      return res.data.data;
    } catch (error) {
      dispatch("errorGETHandler", error, { root: true });
      return null;
    } finally {
      commit("setLoadingBtn", false, { root: true });
    }
  },

  async getFinancialDraftFromReceiptForm({ dispatch, commit }, receiptId) {
    commit("setLoadingBtn", true, { root: true });
    try {
      const res = await axios.get(
        splyUrl + "operation/Draft/FinancialFromReceiptForm/" + receiptId,
      );
      return res.data.data;
    } catch (error) {
      dispatch("errorGETHandler", error, { root: true });
      return null;
    } finally {
      commit("setLoadingBtn", false, { root: true });
    }
  },

  editDraft({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/Draft/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editFinancialDraft({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/Draft/UpdateFinancial/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteDraft({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/Draft", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getDraftCode({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/Draft/MaxCode?wareId=" + data)
      .then((res) => {
        commit("setDraftCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getDraftSerial({ dispatch, commit }) {
    axios
      .get(splyUrl + "operation/Draft/MaxSerial")
      .then((res) => {
        commit("setDraftSerial", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  async getReceiptFromDraftForm({ dispatch, commit }, draftId) {
    commit("setLoadingBtn", true, { root: true });
    try {
      const res = await axios.get(
        splyUrl + "operation/Receipt/FromDraftForm/" + draftId,
      );
      return res.data.data;
    } catch (error) {
      dispatch("errorGETHandler", error, { root: true });
      return null;
    } finally {
      commit("setLoadingBtn", false, { root: true });
    }
  },

  async getFinancialReceiptFromDraftForm({ dispatch, commit }, draftId) {
    commit("setLoadingBtn", true, { root: true });
    try {
      const res = await axios.get(
        splyUrl + "operation/Receipt/FinancialFromDraftForm/" + draftId,
      );
      return res.data.data;
    } catch (error) {
      dispatch("errorGETHandler", error, { root: true });
      return null;
    } finally {
      commit("setLoadingBtn", false, { root: true });
    }
  },

  // نسخه‌ی بدون commit ناوبری؛ برای یافتن برگه بعدی/قبلی پیش از حذف
  fetchDraftNavigation(context, data) {
    return axios
      .get(splyUrl + "operation/Draft/Navigation?" + data)
      .then((res) => res.data.data || null)
      .catch(() => null);
  },

  getDraftNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/Draft/Navigation?" + data)
      .then((res) => {
        commit("setDraftNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintDraft({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(splyUrl + "operation/Draft/Print/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getDraftCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/Draft/DraftNoVoucher")
      .then((res) => {
        commit("setDraftCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getDraftVerification({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/Draft/DraftCartable")
      .then((res) => {
        commit("setDraftVerificationCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addDraftChangeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Draft/changeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  draftReturnStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios

      .post(splyUrl + "operation/Draft/Return", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getDraftConfirmCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/draft/confirmCartable")
      .then((res) => {
        commit("setDraftConfirmCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getDraftValue({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/Draft/GetValue?" + data)
      .then((res) => {
        commit("setDraftValue", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  fetchDraftValue({ dispatch }, data) {
    return axios
      .get(splyUrl + "operation/Draft/GetValue?" + data)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  addDraftConfirm({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/draft/confirm", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getDraftUnConfirmCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/draft/unConfirmCartable")
      .then((res) => {
        commit("setDraftUnConfirmCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addDraftUnConfirm({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/draft/ChangeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addDraftCheckCreate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Draft/CreateCheck", data)
      .then((res) => {
        commit("setDraftCheckCreate", checkResultRows(res.data.data));
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addDraftCheckUpdate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Draft/UpdateCheck", data)
      .then((res) => {
        commit("setDraftCheckUpdate", checkResultRows(res.data.data));
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  importExcelDraft({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Draft/ImportAsExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: res.data.message,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getDraftVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Draft/GetAddVoucher", data)
      .then((res) => {
        commit("setDraftVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addDraftVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Draft/IssuanceVoucher", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // صدور فاکتور فروش از روی حواله(های) انبار
  // data: { draftIds: [id], mode, saleFactorId, saleTypeId }
  createSaleFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Draft/CreateSaleFactor", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // صدور فاکتور مرجوعی خرید از روی حواله(های) انبار
  // data: { draftIds: [id], mode, returnBuyFactorId, buyTypeId }
  createReturnBuyFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Draft/CreateReturnBuyFactor", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteDraftVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/Draft/DeleteVoucher", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReadDraftRequestByCode({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/Draft/ReadDraftRequest?code=" + data)
      .then((res) => {
        commit("setReadDraftRequestByCode", res.data.data);
        dispatch(
          "successPOSTHandlerSilent2",
          {
            server: res,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // DraftAttachment Actions ------------------------------------------------------------------
  getDraftAttachments({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/DraftAttach?draftId=" + data)
      .then((res) => {
        commit("setDraftAttachments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addDraftAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/DraftAttach", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteDraftAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/DraftAttach", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // DraftRequest Actions ------------------------------------------------------------------
  getDraftRequests({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/DraftRequest?" + data)
      .then((res) => {
        commit("setDraftRequests", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getDraftRequest({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/DraftRequest/GetOne?" + data)
      .then((res) => {
        commit("setDraftRequest", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addDraftRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/DraftRequest", data)
      .then((res) => {
        commit("setDraftRequestCreateResult", res.data.data);
        commit("setDraftRequestId", res.data.data?.id);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editDraftRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/DraftRequest/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addDraftRequestCheckCreate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/DraftRequest/CreateCheck", data)
      .then((res) => {
        commit("setDraftRequestCheckCreate", checkResultRows(res.data.data));
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addDraftRequestCheckUpdate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/DraftRequest/UpdateCheck", data)
      .then((res) => {
        commit("setDraftRequestCheckUpdate", checkResultRows(res.data.data));
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteDraftRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/DraftRequest", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getDraftRequestCode({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/DraftRequest/MaxCode?wareId=" + data)
      .then((res) => {
        commit("setDraftRequestCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDraftRequestSerial({ dispatch, commit }) {
    axios
      .get(splyUrl + "operation/DraftRequest/MaxSerial")
      .then((res) => {
        commit("setDraftRequestSerial", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // نسخه‌ی بدون commit ناوبری؛ برای یافتن برگه بعدی/قبلی پیش از حذف
  fetchDraftRequestNavigation(context, data) {
    return axios
      .get(splyUrl + "operation/DraftRequest/Navigation?" + data)
      .then((res) => res.data.data || null)
      .catch(() => null);
  },

  getDraftRequestNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/DraftRequest/Navigation?" + data)
      .then((res) => {
        commit("setDraftRequestNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintDraftRequest({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(splyUrl + "operation/DraftRequest/Print/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // Sort WaresVoucher Actions ------------------------------------------------------------------
  sortSerialReceipt({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/Receipt/SortSerial")
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  sortCodeWaresReceipt({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/Receipt/SortCode")
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  sortSerialDrafts({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/Draft/SortSerial")
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  sortCodeWaresDrafts({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/Draft/SortCode")
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getDraftRequestCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/DraftRequest/UnConfirmCartable")
      .then((res) => {
        commit("setDraftRequestCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addDraftRequestConfirm({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/DraftRequest/Confirm", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addDraftRequestDisconfirm({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/DraftRequest/UnConfirm", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Reports Actions ------------------------------------------------------------------
  getNumeralCirculationReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/NumeralCirculation?" + data)
      .then((res) => {
        commit("setNumeralCirculation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getRialCirculationReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/RialCirculation?" + data)
      .then((res) => {
        commit("setRialCirculation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // TransferCommodity Actions ------------------------------------------------------------------
  getTransferCommodities({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/TransferCommodity?" + data)
      .then((res) => {
        commit("setTransferCommodities", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getTransferCommodity({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/transferCommodity/" + data)
      .then((res) => {
        commit("setTransferCommodity", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addTransferCommodity({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/transferCommodity", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addProcessTransferCommodity({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/transferCommodity/createProcess", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editTransferCommodity({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/TransferCommodity/Update/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editProcessTransferCommodity({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        splyUrl + "operation/TransferCommodity/UpdateProcess/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteTransferCommodity({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/transferCommodity", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getTransferCommodityCode({ dispatch, commit }) {
    axios
      .get(splyUrl + "operation/transferCommodity/maxCode")
      .then((res) => {
        commit("setTransferCommodityCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTransferCommodityCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/transferCommodity/confirmCartable")
      .then((res) => {
        commit("setTransferCommodityCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addTransferCommodityConfirm({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/transferCommodity/confirm", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getNumeralCardexReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/NumeralCardex?" + data)
      .then((res) => {
        commit("setNumeralCardex", res.data.data.list);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getRialCardexReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/RialCardex?" + data)
      .then((res) => {
        commit("setRialCardex", res.data.data.list);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getCirculationCommodity({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/CirculationCommodity?" + data)
      .then((res) => {
        commit("setCirculationCommodity", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getInventoryDeduction({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/InventoryDeduction")
      .then((res) => {
        commit("setInventoryDeduction", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getInventorySummary({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/InventorySummary")
      .then((res) => {
        commit("setInventorySummary", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getInventorySummaryDetail({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "Report/InventorySummaryDetail?commodityId=" + data)
      .then((res) => {
        commit("setInventorySummaryDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCommoditySleepReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/CommoditySleep?" + data)
      .then((res) => {
        commit("setCommoditySleep", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getCommodityCirculationReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/CommodityCirculation?" + data)
      .then((res) => {
        commit("setCommodityCirculation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintCommoditySleepReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        splyUrl + "Report/PrintCommoditySleep?reportId=" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getNegativeCommodityReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/NegativeCommodity?" + data)
      .then((res) => {
        commit("setNegativeCommodity", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getWareDocumentReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/WareDocument?" + data)
      .then((res) => {
        commit("setWareDocument", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getWareFinancialDocumentReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/WareFinancialDocument?" + data)
      .then((res) => {
        commit("setWareFinancialDocument", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getNumeralInventoryReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/NumeralInventory?" + data)
      .then((res) => {
        commit("setNumeralInventory", res.data.data.list);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getRialInventoryReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/RialInventory?" + data)
      .then((res) => {
        commit("setRialInventory", res.data.data.list);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // CommodityConversion Actions ------------------------------------------------------------------
  addCommodityConversion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/commodityConversion", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Warehousing Actions ------------------------------------------------------------------
  getWarehousings({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/warehousing?" + data)
      .then((res) => {
        commit("setWarehousings", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getWarehousing({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/Warehousing/" + data)
      .then((res) => {
        commit("setWarehousing", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addWarehousing({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/Warehousing", data)
      .then((res) => {
        commit("setWarehousingCreateResult", res.data.data);
        commit("setWarehousingId", res.data.data?.id);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editWarehousing({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/warehousing/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteWarehousing({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/warehousing", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getWarehousingCommodityByWare({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/Warehousing/Commodities?wareId=" + data)
      .then((res) => {
        commit("setWarehousingCommodityByWare", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPrintWarehousing({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(splyUrl + "operation/Warehousing/Print/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // WarehousingCommodity Actions ------------------------------------------------------------------
  getWarehousingCommodities({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        splyUrl +
          "operation/WarehousingCommodity?isContradiction=false&" +
          data,
      )
      .then((res) => {
        commit("setWarehousingCommodities", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getWarehousingContradictions({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        splyUrl + "operation/WarehousingCommodity?isContradiction=true&" + data,
      )
      .then((res) => {
        commit("setWarehousingContradictions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addWarehousingCommodity({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/WarehousingCommodity", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  importExcelWarehousingCommodity({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/WarehousingCommodity/ImportAsExcel", data)
      .then((res) => {
        commit("setErrorMessage", res.data.data, { root: true });
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addWarehousingReceiptDraft({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/WarehousingCommodity/AddReceiptDraft", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintgetWarehousingCommodity({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        splyUrl + "operation/WarehousingCommodity/Print/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // WarehousingCommodityBatch Actions ------------------------------------------------------------------
  getWarehousingCommodityBatches({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/WarehousingCommodityBatch?" + data)
      .then((res) => {
        commit("setWarehousingCommodityBatches", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  addWarehousingCommodityBatch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/WarehousingCommodityBatch", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  importExcelWarehousingCommodityBatch({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/WarehousingCommodityBatch/ImportAsExcel", data)
      .then((res) => {
        commit("setErrorMessage", res.data.data, { root: true });
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteWarehousingCommodityBatch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/WarehousingCommodityBatch", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // WarehousingTag Actions ------------------------------------------------------------------
  getWarehousingTag({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/WarehousingTag/Search?" + data)
      .then((res) => {
        commit("setWarehousingTag", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // گزارش تگ را مستقیم می‌گیرد تا reportDropDown مشترکِ منوی چاپ بازنویسی نشود
  printWarehousingTags({ dispatch, commit }, warehousingId) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .get("base/api/v1/DropDown/Report?reportTypeId=122&subSystemId=24")
      .then((res) => {
        const reports = res.data.data || [];
        if (!reports.length) return;
        // مقدار قبلی پاک می‌شود تا لینک تکراری هم دوباره باز شود
        commit("setPrintLink", null);
        return axios
          .post(splyUrl + "operation/WarehousingTag/Print/" + reports[0].id, {
            warehousingId,
          })
          .then((printRes) => {
            commit("setPrintLink", printRes.data.data);
          });
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintWarehousingTag({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(splyUrl + "operation/WarehousingTag/Print/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // CommodityBatch Actions ------------------------------------------------------------------
  getCommodityBatches({ dispatch, commit }) {
    axios
      .get(splyUrl + "basic/CommodityBatch")
      .then((res) => {
        commit("setCommodityBatches", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCommodityBatch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/CommodityBatch", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodityBatch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/CommodityBatch/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCommodityBatch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/CommodityBatch", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // UserLimitWareInfo Actions ------------------------------------------------------------------
  getUserLimitWares({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "basic/UserLimitWareInfo?userId=" + data)
      .then((res) => {
        commit("setUserLimitWares", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  ChangeUserLimitWares({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/UserLimitWareInfo", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteUserLimitWares({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/UserLimitWareInfo", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // BuyRequest Actions ------------------------------------------------------------------
  getReqBuys({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/ReqBuy?" + data)
      .then((res) => {
        commit("setReqBuys", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintBuyRequest({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(splyUrl + "operation/ReqBuy/Print/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getReqBuy({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/ReqBuy/" + data)
      .then((res) => {
        commit("setReqBuy", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addReqBuy({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/ReqBuy", data)
      .then((res) => {
        commit("setReqBuyCreateResult", res.data.data);
        commit("setReqBuyId", res.data.data?.id);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReqBuy({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/ReqBuy/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReqBuy({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/ReqBuy", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReqBuyCode({ dispatch, commit }) {
    axios
      .get(splyUrl + "operation/ReqBuy/MaxCode")
      .then((res) => {
        commit("setReqBuyCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReqBuyNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/ReqBuy/navigation?" + data)
      .then((res) => {
        commit("setReqBuyNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // BuyRequest Buyer Actions ------------------------------------------------------------------
  getNotYetBuyers({ dispatch, commit }) {
    axios
      .get(splyUrl + "operation/ReqBuy/NotYetBuyers")
      .then((res) => {
        commit("setNotYetBuyers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addBuyer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/ReqBuy/SetBuyers", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintBuyer({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        splyUrl + "operation/ReqBuy/PrintNotYetBuyers/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // BuyRequest Cartable Actions ------------------------------------------------------------------
  getReqBuyCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/ReqBuy/UnConfirmCartable")
      .then((res) => {
        commit("setReqBuyCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addReqBuyConfirm({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/ReqBuy/Confirm", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addReqBuyDisconfirm({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/ReqBuy/UnConfirm", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // PackageType Actions ------------------------------------------------------------------
  getPackageTypes({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "basic/PackageType")
      .then((res) => {
        commit("setPackageTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addPackageType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/PackageType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPackageType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/PackageType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePackageType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/PackageType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPackageTypeCode({ dispatch, commit }) {
    axios
      .get(splyUrl + "basic/PackageType/MaxCode")
      .then((res) => {
        commit("setPackageTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // BOM Actions ------------------------------------------------------------------
  getBoms({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "basic/bom")
      .then((res) => {
        commit("setBoms", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBom({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/bom/" + data)
      .then((res) => {
        commit("setBom", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addBom({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/bom", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PMRPBOMList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBom({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/bom/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PMRPBOMList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBom({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/bom", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBomCode({ dispatch, commit }) {
    axios
      .get(splyUrl + "basic/bom/MaxCode")
      .then((res) => {
        commit("setBomCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBomCommodities({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/BomCommodity?bomId=" + data)
      .then((res) => {
        commit("setBomCommodities", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // CommodityInventoryGroupByWare Actions ------------------------------------------------------------------
  getCommodityInventoryWare({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "basic/Commodity/CommodityInventoryGroupByWare?" + data)
      .then((res) => {
        commit("setCommodityInventoryWare", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  //Receipt Notes ---------------------------------------------
  getReceiptNotes({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/ReceiptDocument?receiptId=" + data)
      .then((res) => {
        commit("setReceiptNotes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addReceiptNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/ReceiptDocument", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReceiptNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/ReceiptDocument/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReceiptNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/ReceiptDocument", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //Drafts Notes ---------------------------------------------
  getDraftsNotes({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/DraftDocument?draftId=" + data)
      .then((res) => {
        commit("setDraftsNotes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addDraftsNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/DraftDocument", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editDraftsNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/DraftDocument/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteDraftsNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/DraftDocument", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // BuyType ------------------------------------------------------
  getBuyTypes({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "basic/BuyType")
      .then((res) => {
        commit("setBuyTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addBuyType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/BuyType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBuyType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/BuyType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBuyType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/BuyType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBuyTypeCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "basic/BuyType/GetMaxCode")
      .then((res) => {
        commit("setBuyTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // Cartable Management ..................................................................................

  receiptManagementCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/Receipt/ManagementCartable", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  draftManagementCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/draft/ManagementCartable", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Setting Actions ------------------------------------------------------------------
  getSettings({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "basic/whrs/Setting")
      .then((res) => {
        commit("setSettings", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  editSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/whrs/Setting/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // CartableLog Actions ------------------------------------------------------------------
  getCartableLog({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/whrs/CartableLog?" + data)
      .then((res) => {
        commit("setCartableLog", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // CommodityGroupConfig Actions ------------------------------------------------------------------
  getCommodityGroupConfigs({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "basic/CommodityGroupConfig")
      .then((res) => {
        commit("setCommodityGroupConfigs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addCommodityGroupConfig({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/CommodityGroupConfig", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCommodityGroupConfig({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/CommodityGroupConfig/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCommodityGroupConfig({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/CommodityGroupConfig/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Service actions --------------------------------
  getServices({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "basic/Service")
      .then((res) => {
        commit("setServices", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getService({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/Service/" + data)
      .then((res) => {
        commit("setService", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addService({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/Service", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editService({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/Service/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteService({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/Service", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getServiceSerial({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/Service/GetMaxSerial/" + data)
      .then((res) => {
        commit("setServiceSerial", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // ServiceGroup actions --------------------------------
  getServiceGroups({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "basic/ServiceGroup")
      .then((res) => {
        commit("setServiceGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addServiceGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "basic/ServiceGroup", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editServiceGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "basic/ServiceGroup/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteServiceGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "basic/ServiceGroup/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getServiceGroupCode({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "basic/ServiceGroup/GetMaxCode" + data)
      .then((res) => {
        commit("setServiceGroupCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
};
